import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { goToCheckout, PRICE_LABEL } from '../lib/checkout';
const kitItems = [{
  name: '12 Tomos digitales completos',
  value: '$47'
}, {
  name: '6 Bonos exclusivos',
  value: '$114'
}];
const TOTAL_VALUE = '$161 USD';
export function PricingSection() {
  return <section id="precios" className="py-16 md:py-24 px-5 bg-surface-light" data-id="element-123" data-mp="1nak9v0tlup5b">
      <div className="max-w-2xl mx-auto" data-id="element-124" data-mp="1ncmzvkurcia1">
        {/* Heading */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-125" data-mp="1s8c25vy5wda1">
          <div className="text-4xl mb-2" data-id="element-126" data-mp="2vqs9e7wugxm">🏆</div>
          <h2 className="font-display font-black text-primary text-3xl md:text-5xl leading-tight tracking-tight mb-6" data-id="element-127" data-mp="2x1u38hspem3">
            Oferta Especial de Lanzamiento
          </h2>

          <CountdownTimer data-id="element-128" data-mp="1mhzhz9nawfax" />

          <p className="text-sm md:text-base text-accent font-semibold mt-4" data-id="element-129" data-mp="1hpy9zzx61aqp">
            🔴 El precio sube cuando termina el contador
          </p>
        </motion.div>

        {/* Kit card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative bg-white rounded-3xl border border-primary/5 shadow-sm px-6 pt-12 pb-8 md:px-10 md:pt-14 md:pb-10" data-id="element-130" data-mp="1coiltyzoyo43">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2" data-id="element-131" data-mp="1vfjlyqcjspp8">
            <span className="inline-block bg-accent text-white text-xs md:text-sm font-bold uppercase tracking-wider px-6 py-3 rounded-full shadow-md whitespace-nowrap" data-id="element-132" data-mp="1repytz6xjexe">
              Contenido del kit:
            </span>
          </div>

          <ul className="mb-8" data-id="element-133" data-mp="g2p6696y36cd">
            {kitItems.map((item, index) => <li key={item.name} className={`flex items-center justify-between gap-4 py-4 ${index === 0 ? 'border-b border-primary/10' : ''}`} data-id="element-134" data-mp="hiazvj66s1me" data-mpi={index}>
                <span className="text-sm md:text-base font-semibold text-primary" data-id="element-135" data-mp="7j2a72ict95u">
                  {item.name}
                </span>
                <span className="text-sm md:text-base text-accent/70 line-through whitespace-nowrap" data-id="element-136" data-mp="ckhx7043dpqv">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="flex items-center justify-between gap-4 mb-8" data-id="element-137" data-mp="3kyi4pt0c84wr">
            <span className="font-display font-black text-primary text-base md:text-lg uppercase tracking-wide" data-id="element-138" data-mp="3l0bc5airyt5t">
              Valor total:
            </span>
            <span className="font-display font-bold text-accent/70 text-lg md:text-xl line-through whitespace-nowrap" data-id="element-139" data-mp="3bxjyr56c9nbj">
              {TOTAL_VALUE}
            </span>
          </div>

          <div className="text-center mb-8" data-id="element-140" data-mp="2xatq1iqacsfx">
            <div className="flex items-center justify-center gap-3" data-id="element-141" data-mp="2xbmuue5op7vf">
              <span className="text-3xl md:text-4xl" data-id="element-142" data-mp="2scs66vl1cp3e">🏆</span>
              <span className="font-display font-black text-accent text-5xl md:text-6xl leading-none" data-id="element-143" data-mp="36brsvxozmtwx">
                {PRICE_LABEL}
              </span>
            </div>
            <p className="font-display text-base md:text-lg text-accent/60 line-through mt-3" data-id="element-144" data-mp="31bdi47w055v7">
              {TOTAL_VALUE}
            </p>
          </div>

          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={goToCheckout} className="w-full bg-accent text-white py-5 rounded-full font-bold text-base md:text-xl tracking-wide hover:bg-accent-dark transition-colors shadow-lg" data-id="element-145" data-mp="3bbe2zy9iru1i">
            QUIERO EL KIT STRETCHING 360
          </motion.button>

          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 mt-6 text-xs md:text-sm text-primary/60" data-id="element-146" data-mp="3u2x94dyubo7r">
            <span data-id="element-147" data-mp="hw9nq7xgkp3v">Descarga inmediata</span>
            <span className="text-primary/25" data-id="element-148" data-mp="lymik1ao32lv">·</span>
            <span data-id="element-149" data-mp="lxbh484p26xx">Pago único</span>
            <span className="text-primary/25" data-id="element-150" data-mp="qq4jipcox36u">·</span>
            <span data-id="element-151" data-mp="qsh99ooowhug">Acceso de por vida</span>
            <span className="text-primary/25" data-id="element-152" data-mp="vpqx4zwfklg6">·</span>
            <span data-id="element-153" data-mp="vrlhod3sibjq">7 días de garantía</span>
          </div>

          <p className="text-center text-xs md:text-sm text-primary/40 mt-4" data-id="element-154" data-mp="3v5nuttr1zsa3">
            💱 El pago se procesará en la moneda de tu país
          </p>
        </motion.div>
      </div>
    </section>;
}